import QrIcon from './Icons/QrIcon'
import SupportIcon from './Icons/SupportIcon'
import TranRoutesIcon from './Icons/TranRoutesIcon'

export const getNavItems = (t) => [
  {
    url: '/qr',
    Icon: QrIcon,
    title: t('header.qr_tickets'),
  },
  {
    url: '/tran_routes',
    Icon: TranRoutesIcon,
    title: t('header.routes'),
  },
  {
    url: '/support',
    Icon: SupportIcon,
    title: t('header.support'),
    shortTitle: t('support'),
  },
]
